import * as Yup from 'yup';

export const username = Yup.string()
  .label('Username')
  .min(1, 'Too Short!')
  .max(128, 'Too Long!')
  .lowercase();

export const password = Yup.string().label('Password').min(8).max(128);
